/**
 * Device-bound login PIN (Phase 3). Enrollment/management is authenticated (current device, resolved
 * from the tacita_device cookie); login is pre-auth: device cookie + PIN → session (refresh in cookie).
 * `pinLogin` returns the unified shape — `ctype` tells the client which product to mount.
 */
import { http } from './http';

export interface DevicePinLoginResponse {
  accessToken: string;
  customerId: string;
  sessionId: string;
  ctype: 'SHOWCASE' | 'FULL';
}

export const devicePinApi = {
  /** Set/change the PIN for the current device (marks it trusted). */
  setPin(pin: string) {
    return http.post('/v1/me/device-pin', { pin });
  },

  status() {
    return http.get<{ enabled: boolean }>('/v1/me/device-pin/status').then(r => r.data);
  },

  clearPin() {
    return http.delete('/v1/me/device-pin');
  },

  /** Verify-only re-proof (app-lock unlock) — does NOT issue a new session. */
  verify(pin: string) {
    return http.post<{ ok: boolean; status: string }>('/v1/me/device-pin/verify', { pin }).then(r => r.data);
  },

  /** Pre-auth login with the device PIN (device cookie carries identity). */
  pinLogin(pin: string) {
    return http.post<DevicePinLoginResponse>('/v1/device-pin/login', { pin }).then(r => r.data);
  },

  /** Pre-auth: does this browser have a device PIN? (anti-enum boolean) — drives the login "PIN" option. */
  available() {
    return http.get<{ pinSet: boolean }>('/v1/device-pin/available').then(r => r.data);
  },
};
